import { render } from "./InputForm.vue?vue&type=template&id=2916d464"
import script from "./InputForm.vue?vue&type=script&lang=js"
export * from "./InputForm.vue?vue&type=script&lang=js"
script.render = render

export default script